import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kiacarenceonrentinshirdi() {



    const cardData = {





keyword: "Kia Carens on Rent in Shirdi",

headingDescription: "Sai Shirdi Cab provides Kia Carens on Rent in Shirdi for families, devotees, tourists, corporate travelers, and small groups looking for a spacious and comfortable vehicle for outstation journeys. Kia Carens is a suitable choice for customers who need comfortable seating, generous cabin space, and convenient luggage capacity during long-distance travel from Shirdi. Customers can hire Kia Carens with a professional driver for one-way trips, round trips, multi-day journeys, pilgrimage tours, family vacations, sightseeing, business travel, and customized outstation itineraries. Popular destinations from Shirdi include Nashik, Chhatrapati Sambhajinagar, Ahmednagar, Pune, Mumbai, Shani Shingnapur, Trimbakeshwar, Bhimashankar, Saptashrungi, and Ajanta-Ellora. Sai Shirdi Cab offers clean and well-maintained vehicles, experienced drivers, flexible pickup timings, and convenient door-to-door transportation. Kia Carens is particularly useful for families and groups who want a comfortable private vehicle for longer outstation journeys from Shirdi.",

topPlaces: [
  {
    title: "Nashik",
    description: "Nashik is a popular outstation destination from Shirdi for pilgrimage, sightseeing, family travel, and business visits. Customers can rent a Kia Carens for comfortable transportation from Shirdi to Nashik, with spacious seating and luggage capacity for families and groups. Trimbakeshwar can also be included in the itinerary."
  },
  {
    title: "Chhatrapati Sambhajinagar",
    description: "Chhatrapati Sambhajinagar is an important destination from Shirdi for heritage sightseeing, family trips, business travel, and religious journeys. Kia Carens offers comfortable private transportation for passengers traveling together. Customers can choose one-way, round-trip, or customized outstation travel."
  },
  {
    title: "Ahmednagar",
    description: "Ahmednagar is a convenient outstation destination from Shirdi for business, family visits, and personal travel. Customers can hire a Kia Carens with a professional driver for direct or round-trip transportation. Its spacious cabin makes it suitable for families and small groups traveling with luggage."
  },
  {
    title: "Pune",
    description: "Pune is a major outstation destination from Shirdi for corporate travel, family visits, education, medical appointments, and tourism. Customers can rent a Kia Carens for a comfortable journey from Shirdi to Pune. The vehicle provides a practical option for families and groups requiring additional seating and luggage space."
  },
  {
    title: "Mumbai",
    description: "Mumbai is a major long-distance destination from Shirdi for business, tourism, family travel, and airport-related journeys. Customers can book a Kia Carens with a professional driver for convenient door-to-door travel. One-way, round-trip, and multi-day bookings can be arranged according to the itinerary."
  },
  {
    title: "Shani Shingnapur",
    description: "Shani Shingnapur is a popular pilgrimage destination that can be covered from Shirdi by private Kia Carens. Families and devotees can enjoy comfortable round-trip transportation with flexible travel timings. The journey can also be combined with other nearby religious destinations."
  },
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is a prominent Jyotirlinga destination that can be visited from Shirdi by Kia Carens. Customers can plan a comfortable private pilgrimage covering Shirdi, Nashik, and Trimbakeshwar in one itinerary. The spacious vehicle is suitable for families and small groups."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is an important pilgrimage destination that can be included in an outstation journey from Shirdi. Customers can rent a Kia Carens for a comfortable round trip with flexible pickup and return timings. The itinerary can also include other religious and sightseeing destinations."
  },
  {
    title: "Saptashrungi",
    description: "Saptashrungi Devi Temple at Vani is a popular pilgrimage destination from Shirdi. Customers can hire a Kia Carens for comfortable family and group travel to the temple. The journey can be customized to include Nashik and other nearby pilgrimage destinations for a broader religious tour."
  },
  {
    title: "Ajanta-Ellora Caves",
    description: "Ajanta and Ellora Caves are popular heritage destinations that can be covered from Shirdi through a customized Kia Carens trip. Customers can plan a full-day or multi-day sightseeing journey with convenient stops along the route. The spacious vehicle is suitable for families and groups carrying luggage."
  }
],








"services": [
{
"name": "Kia Carens on Rent in Shirdi",
"description": "Kia Carens on Rent in Shirdi provides a spacious and comfortable private travel option for families, groups, and travelers. The vehicle can be arranged for local trips, sightseeing, Sai Baba darshan, airport transfers, railway station pickups, and outstation journeys according to travel requirements."
},
{
"name": "Kia Carens Rental Shirdi",
"description": "Kia Carens Rental Shirdi offers a practical vehicle option for passengers looking for comfortable seating and generous luggage space. Rental arrangements can be planned according to passenger count, travel duration, pickup location, destination, preferred timing, and one-way or round-trip requirements."
},
{
"name": "Kia Carens Car Rental Shirdi",
"description": "Kia Carens Car Rental Shirdi provides private transportation for families, tourists, and small groups traveling around Shirdi or toward other destinations. Customers can organize the rental according to their itinerary, passenger requirements, luggage, travel schedule, and selected trip type."
},
{
"name": "Kia Carens Cab on Rent Shirdi",
"description": "Kia Carens Cab on Rent Shirdi provides a comfortable and spacious cab option for passengers requiring private transportation. The vehicle can be arranged for pilgrimage travel, family trips, sightseeing, airport transfers, railway station pickups, hotel transfers, and outstation journeys."
},
{
"name": "Kia Carens Taxi on Rent Shirdi",
"description": "Kia Carens Taxi on Rent Shirdi is suitable for travelers who prefer a spacious private taxi for local and intercity transportation. The service can be planned according to passenger capacity, luggage requirements, pickup timing, destination, travel duration, and one-way or return journey needs."
},
{
"name": "Kia Carens Hire in Shirdi",
"description": "Kia Carens Hire in Shirdi offers a convenient vehicle hire option for families, groups, tourists, and business travelers. Customers can arrange the vehicle according to their travel duration, passenger count, luggage, pickup location, destination, and preferred travel itinerary."
},
{
"name": "Kia Carens Car Hire Shirdi",
"description": "Kia Carens Car Hire Shirdi provides private transportation for travelers looking for a comfortable and spacious vehicle. The car can be hired for local sightseeing, temple visits, airport transfers, railway station travel, family outings, and longer outstation journeys."
},
{
"name": "Kia Carens With Driver Shirdi",
"description": "Kia Carens With Driver Shirdi provides a chauffeur-driven travel option for customers who prefer convenient private transportation. The vehicle can be arranged for Sai Baba darshan, sightseeing, family travel, airport transfers, railway station pickups, and outstation trips according to the planned itinerary."
},
{
"name": "Kia Carens Outstation Rental Shirdi",
"description": "Kia Carens Outstation Rental Shirdi is suitable for travelers planning comfortable long-distance journeys from Shirdi to other cities and destinations. Rental arrangements can be organized according to route, travel duration, passenger count, luggage, pickup point, destination, and preferred trip type."
},
{
"name": "Kia Carens One Way Rental Shirdi",
"description": "Kia Carens One Way Rental Shirdi provides direct private transportation for passengers who require a single journey without booking a return trip. The vehicle can be scheduled from the preferred pickup location in Shirdi to the selected destination according to travel date and passenger requirements."
},
{
"name": "Kia Carens Round Trip Rental Shirdi",
"description": "Kia Carens Round Trip Rental Shirdi is a convenient option for families and groups planning to travel to another destination and return to Shirdi. The rental can be organized according to travel dates, stay duration, passenger count, luggage, waiting requirements, and return schedule."
},
{
"name": "Kia Carens Airport Cab Shirdi",
"description": "Kia Carens Airport Cab Shirdi provides spacious private transportation for airport pickup and drop requirements. The cab can be coordinated with flight timings and arranged according to passenger count, luggage capacity, airport location, pickup timing, and final destination."
},
{
"name": "Kia Carens Railway Station Cab Shirdi",
"description": "Kia Carens Railway Station Cab Shirdi offers comfortable transportation for passengers arriving at or departing from railway stations around Shirdi. Pickup and drop arrangements can be scheduled according to train timings, passenger requirements, luggage, preferred vehicle, and destination."
},
{
"name": "Kia Carens Tourist Cab Shirdi",
"description": "Kia Carens Tourist Cab Shirdi provides a spacious travel option for families and groups exploring Shirdi and nearby tourist or pilgrimage destinations. The cab can be arranged for sightseeing, temple visits, local tours, family outings, and customized itineraries with convenient pickup and drop arrangements."
},
{
"name": "Kia Carens Booking Shirdi",
"description": "Kia Carens Booking Shirdi allows travelers to reserve a spacious private vehicle in advance for their planned journey. Customers can provide travel dates, pickup timing, passenger count, luggage requirements, destination, rental duration, and preferred one-way or round-trip transportation."
},
{
"name": "Kia Carens Cab Booking Shirdi",
"description": "Kia Carens Cab Booking Shirdi provides a convenient way to arrange private transportation for local, pilgrimage, sightseeing, airport, railway station, and outstation travel. Booking details can be organized according to pickup point, travel schedule, passenger capacity, luggage, destination, and trip requirements."
},
{
"name": "Kia Carens for Family Trip Shirdi",
"description": "Kia Carens for Family Trip Shirdi provides comfortable transportation for families traveling together with luggage and personal belongings. The spacious vehicle can be used for Sai Baba darshan, sightseeing, nearby destinations, airport transfers, railway station travel, and longer family journeys."
},
{
"name": "Kia Carens for Outstation Shirdi",
"description": "Kia Carens for Outstation Shirdi offers a spacious private vehicle for travelers planning long-distance journeys from Shirdi. It can be arranged for family trips, group travel, pilgrimage routes, sightseeing tours, one-way transportation, and round-trip itineraries based on the travel plan."
},
{
"name": "Affordable Kia Carens Rental Shirdi",
"description": "Affordable Kia Carens Rental Shirdi provides a practical transportation option for travelers looking for a spacious vehicle while keeping their planned travel budget in mind. Rental arrangements can be selected according to journey type, travel duration, passenger count, luggage, route, and vehicle usage."
},
{
"name": "Best Kia Carens Cab Service Shirdi",
"description": "Best Kia Carens Cab Service Shirdi provides comfortable private transportation for families, groups, tourists, and travelers visiting Shirdi. The cab can be arranged for local travel, Sai Baba darshan, sightseeing, airport transfers, railway station pickups, and outstation journeys according to the preferred itinerary."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides Kia Carens and other suitable private vehicles for local travel, pilgrimage journeys, sightseeing, airport transfers, railway station pickups, family trips, and outstation transportation. Vehicle arrangements can be planned according to passenger count, luggage, travel schedule, destination, and trip requirements."
}
],
"tableData": [
["Kia Carens on Rent in Shirdi", "Kia Carens Rental Shirdi"],
["Kia Carens Car Rental Shirdi", "Kia Carens Cab on Rent Shirdi"],
["Kia Carens Taxi on Rent Shirdi", "Kia Carens Hire in Shirdi"],
["Kia Carens Car Hire Shirdi", "Kia Carens With Driver Shirdi"],
["Kia Carens Outstation Rental Shirdi", "Kia Carens One Way Rental Shirdi"],
["Kia Carens Round Trip Rental Shirdi", "Kia Carens Airport Cab Shirdi"],
["Kia Carens Railway Station Cab Shirdi", "Kia Carens Tourist Cab Shirdi"],
["Kia Carens Booking Shirdi", "Kia Carens Cab Booking Shirdi"],
["Kia Carens for Family Trip Shirdi", "Kia Carens for Outstation Shirdi"],
["Affordable Kia Carens Rental Shirdi", "Best Kia Carens Cab Service Shirdi"],
["Sai Shirdi Cabs", "Kia Carens on Rent in Shirdi"]
]
,







    whychoose: [
        { 
            WhyChooseheading: "Kia Carens on Rent in Shirdi for Family & Group Travel", 
            WhyChoosedescription: "Sai Shirdi Cabs provides Kia Carens on rent in Shirdi for families, devotees, tourists, corporate travellers, and small groups who want a spacious private vehicle. Kia Carens can be arranged for Sai Baba Darshan, Shirdi sightseeing, airport transfers, railway station travel, hotel transfers, and outstation journeys according to your itinerary." 
        }, 
        { 
            WhyChooseheading: "Spacious Car for Comfortable Group Travel", 
            WhyChoosedescription: "Kia Carens is a practical option for families and groups who need additional cabin space for passengers and luggage. It can be considered for both local travel and longer journeys where travellers prefer to stay together in one private vehicle." 
        }, 
        { 
            WhyChooseheading: "Kia Carens for Sai Baba Darshan", 
            WhyChoosedescription: "Devotees can rent a Kia Carens for transportation between their hotel, Sai Baba Temple, railway station, and nearby pilgrimage locations. A private vehicle allows families and groups to plan their Darshan-related travel according to their preferred schedule." 
        }, 
        { 
            WhyChooseheading: "Convenient Shirdi Sightseeing by Kia Carens", 
            WhyChoosedescription: "Explore Shirdi and nearby attractions in a private Kia Carens according to your sightseeing plan. Multiple stops can be included based on your selected destinations, available time, and travel requirements." 
        }, 
        { 
            WhyChooseheading: "Airport & Railway Station Transfers", 
            WhyChoosedescription: "Kia Carens can be arranged for airport and railway station pickup or drop services in and around Shirdi. Its spacious interior can be useful for families and groups travelling with luggage." 
        }, 
        { 
            WhyChooseheading: "One-Way & Round-Trip Rental Options", 
            WhyChoosedescription: "Choose a one-way Kia Carens service when you need direct transportation to another destination, or arrange a round-trip rental when the vehicle is required for both onward and return travel from Shirdi." 
        }, 
        { 
            WhyChooseheading: "Suitable for Outstation & Multi-Day Trips", 
            WhyChoosedescription: "Rent a Kia Carens for outstation journeys from Shirdi to destinations such as Nashik, Mumbai, Pune, Aurangabad, Indore, Goa, and other cities or tourist locations. Multi-day travel can also be planned according to your itinerary." 
        }, 
        { 
            WhyChooseheading: "Book Kia Carens on Rent in Shirdi with Sai Shirdi Cabs", 
            WhyChoosedescription: "Share your pickup location, destination, travel date, passenger count, luggage details, rental duration, one-way or round-trip requirement, and preferred travel schedule with Sai Shirdi Cabs to arrange a suitable Kia Carens rental." 
        } 
    ] 

}; 

const faqData = [ 
    { 
        question: "Can I rent a Kia Carens in Shirdi?", 
        answer: "Yes, Sai Shirdi Cabs provides Kia Carens rental services in Shirdi for family travel, Sai Baba Darshan, sightseeing, airport transfers, railway station travel, and outstation journeys." 
    }, 
    { 
        question: "Is Kia Carens suitable for family travel?", 
        answer: "Yes, Kia Carens is a spacious vehicle option for families and small groups travelling with passengers and luggage, subject to the vehicle's seating and luggage capacity." 
    }, 
    { 
        question: "Can I book Kia Carens for Sai Baba Darshan?", 
        answer: "Yes, Kia Carens can be arranged for transportation between your hotel, Sai Baba Temple, railway station, and nearby pilgrimage destinations." 
    }, 
    { 
        question: "Can I use Kia Carens for Shirdi sightseeing?", 
        answer: "Yes, a private Kia Carens can be booked for Shirdi sightseeing and nearby attractions according to your preferred itinerary and travel schedule." 
    }, 
    { 
        question: "Can I book Kia Carens for airport pickup and drop?", 
        answer: "Yes, Kia Carens can be arranged for airport pickup and drop services according to your flight schedule, passenger count, and luggage requirements." 
    }, 
    { 
        question: "Can I book Kia Carens from Shirdi Railway Station?", 
        answer: "Yes, Kia Carens can be arranged for railway station pickup or drop according to your train schedule, passenger count, and luggage requirements." 
    }, 
    { 
        question: "Can I rent Kia Carens for a one-way trip from Shirdi?", 
        answer: "Yes, one-way Kia Carens travel can be arranged for passengers who require direct transportation from Shirdi to another destination without needing the same vehicle for the return journey." 
    }, 
    { 
        question: "Can I book Kia Carens for outstation travel from Shirdi?", 
        answer: "Yes, Kia Carens can be booked for outstation journeys from Shirdi to various cities, tourist destinations, and pilgrimage locations according to your travel plans." 
    }, 
    { 
        question: "Can I rent Kia Carens for a multi-day trip?", 
        answer: "Yes, multi-day Kia Carens rental arrangements can be discussed for extended sightseeing tours, pilgrimage journeys, family vacations, and multi-city travel from Shirdi." 
    }, 
    { 
        question: "How can I book Kia Carens on Rent in Shirdi?", 
        answer: "Share your pickup point, destination, travel date, passenger count, luggage details, rental duration, and one-way or return requirement with Sai Shirdi Cabs to proceed with the Kia Carens booking." 
    } 
]; 

const testimonials = [ 
    { 
        id: 1, 
        name: "Mr. Vikram Jadhav", 
        feedback: "We rented a Kia Carens in Shirdi for our family pilgrimage and sightseeing trip. The spacious vehicle was convenient for our group and luggage, especially while travelling between different locations.", 
        rating: 5 
    }, 
    { 
        id: 2, 
        name: "Mrs. Anjali Patil", 
        feedback: "Our group booked a Kia Carens for an outstation journey from Shirdi. Having a private and spacious vehicle made it easier for everyone to travel together with our bags.", 
        rating: 5 
    } 
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kia Carens on Rent in Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/kia-carens-on-rent-in-shirdi.webp",
  "description":
    "Book a Kia Carens on Rent in Shirdi with Sai Shirdi Cabs for comfortable, spacious, and reliable local and outstation travel. Get a well-maintained Kia Carens with professional driver service for Sai Baba Darshan, Shirdi sightseeing, airport transfers, railway station transfers, family trips, one-way journeys, round trips, and outstation travel. Enjoy convenient pickup and drop locations, affordable rental service, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/kia-carens-on-rent-in-shirdi"
  }
};




    return (
        <div>



<Helmet>
  <title>Kia Carens on Rent in Shirdi | Kia Carens Rental | +91 7776814559</title>

  <meta
    name="description"
    content="Book Kia Carens on rent in Shirdi with Sai Shirdi Cabs. Get a spacious and comfortable Kia Carens with driver for Sai Baba Darshan, sightseeing, airport and railway station transfers, family trips, one-way, round trips and outstation travel."
  />

  <meta
    name="keywords"
    content="Kia Carens on Rent in Shirdi, Kia Carens rental Shirdi, Kia Carens car rental Shirdi, Kia Carens cab on rent Shirdi, Kia Carens taxi on rent Shirdi, Kia Carens hire in Shirdi, Kia Carens with driver Shirdi, Kia Carens cab rental Shirdi, Kia Carens car hire Shirdi, Kia Carens outstation rental Shirdi, Kia Carens one way rental Shirdi, Kia Carens round trip rental Shirdi, Kia Carens airport cab Shirdi, Kia Carens railway station cab Shirdi, Kia Carens booking Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/82.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Kiacarenceonrentinshirdi;